import { compare, lerp } from "common/math";
import { cancel, createPromise } from "common/promises";
import { getMaxClicks } from "./buttonInputFilter";
export const startPoint = {
    left: {
        x: -0,
        y: -1000,
    },
    right: {
        x: 0,
        y: -1000,
    },
};
export const endPoint = {
    left: {
        x: -500,
        y: 100,
    },
    right: {
        x: 500,
        y: 100,
    },
};
export class BackgroundPersonAnimator {
    constructor({ backgroundPerson, pixiContext, }) {
        this.following = null;
        this.pixiContext = pixiContext;
        this.leftSprite = backgroundPerson.leftSprite;
        this.rightSprite = backgroundPerson.rightSprite;
        this.maxSpeed = 4;
        this.currentSpeed = 0;
        this.state = {
            id: "idle",
        };
    }
    dispose() {
        var _a;
        (_a = this.following) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
    }
    animateBeginning() {
        this.state = {
            id: "initialAnimation",
        };
    }
    moveToTop() {
        this.leftSprite.x = startPoint.left.x;
        this.leftSprite.y = startPoint.left.y;
        this.rightSprite.x = startPoint.right.x;
        this.rightSprite.y = startPoint.right.y;
        this.currentSpeed = 0;
    }
    moveToBottom() {
        this.leftSprite.x = endPoint.left.x;
        this.leftSprite.y = endPoint.left.y;
        this.rightSprite.x = endPoint.right.x;
        this.rightSprite.y = endPoint.right.y;
        this.currentSpeed = this.maxSpeed;
    }
    setState(speed, clickCount) {
        this.state = {
            id: "run",
            speed,
            clickCount,
        };
    }
    getStateSpeed() {
        if (this.state.id === "run") {
            // 각 속도별로 일직선상에서 어디까지 움직일 것인가.
            const appearSpeed = 2;
            const appearClick = 3;
            const disappearedSpeed = 3;
            const disappearedClick = 4;
            const beforePos = 1;
            const appearedPos = 2.5;
            const bottomPos = 5;
            const compareWithStart = compare([this.state.speed, this.state.clickCount], [appearSpeed, appearClick]);
            if (compareWithStart === "lt") {
                return beforePos;
            }
            else if (compareWithStart === "eq") {
                return appearedPos;
            }
            const compareWithEnd = compare([this.state.speed, this.state.clickCount], [disappearedSpeed, disappearedClick]);
            if (compareWithEnd === "gt") {
                return bottomPos;
            }
            const middleSteps = getMaxClicks(appearSpeed) - appearClick + disappearedClick;
            let currentStep = 0;
            if (this.state.speed === appearSpeed) {
                currentStep = this.state.clickCount - appearClick;
            }
            else if (this.state.speed === disappearedSpeed) {
                currentStep =
                    getMaxClicks(appearSpeed) - appearClick + this.state.clickCount;
            }
            return lerp(appearedPos, bottomPos, currentStep / middleSteps);
        }
        else if (this.state.id === "finish") {
            return this.maxSpeed;
        }
        else if (this.state.id === "initialAnimation") {
            return 0;
        }
        else {
            return null;
        }
    }
    followGoal() {
        this.following = cancel.root(async (canceler) => {
            const { promise, resolve } = await createPromise();
            const ticker = this.pixiContext.ticker;
            const tick = () => {
                if (canceler.canceled) {
                    resolve();
                    return;
                }
                if (this.currentSpeed === this.getStateSpeed()) {
                    if (this.state.id === "finish") {
                        console.log("background person follow finished");
                        ticker.remove(tick);
                        this.updatePos();
                        resolve();
                        return;
                    }
                    return;
                }
                const ms = ticker.deltaMS;
                const goalSpeed = this.getStateSpeed();
                if (goalSpeed == null) {
                    return;
                }
                if (this.currentSpeed < goalSpeed) {
                    if (this.currentSpeed + ms / 1000 >= goalSpeed) {
                        this.currentSpeed = goalSpeed;
                    }
                    else {
                        this.currentSpeed += ms / 1000;
                    }
                    this.updatePos();
                }
                else if (this.currentSpeed > goalSpeed) {
                    if (this.currentSpeed - ms / 1000 <= goalSpeed) {
                        this.currentSpeed = goalSpeed;
                    }
                    else {
                        this.currentSpeed -= ms / 1000;
                    }
                    this.updatePos();
                }
            };
            ticker.add(tick);
            return promise;
        });
    }
    updatePos() {
        const t = this.currentSpeed / this.maxSpeed;
        this.rightSprite.x = lerp(startPoint.right.x, endPoint.right.x, t);
        this.rightSprite.y = lerp(startPoint.right.y, endPoint.right.y, t);
        this.leftSprite.x = lerp(startPoint.left.x, endPoint.left.x, t);
        this.leftSprite.y = lerp(startPoint.left.y, endPoint.left.y, t);
    }
}
//# sourceMappingURL=backgroundPersonAnimator.js.map